import React, { Fragment } from "react";

import { RadioColumns } from "util/optionColumns";
import ErrorMessage from "util/errorMessage";

import { Form, Columns } from "react-bulma-components";
const { Field, Label } = Form;

function PromptOccupation({ occupationState, onChange }) {
  const {
    optionId: selectedId,
    promptOptions,
  } = occupationState.selectedDetail;

  const academic = [];
  const school = [];
  const practitioner = [];
  const other = [];

  const displayOrder = [
    [
      {
        list: academic,
        label: "Academic (studying / researching at an academic institution)",
      },
      { list: school, label: "Elementary/Secondary School Teacher or Student" },
    ],
    [
      {
        list: practitioner,
        label:
          "Practitioner (working with mathematics in a non-academic environment",
      },

      { list: other, label: "Other" },
    ],
  ];

  promptOptions.forEach((o) => {
    const list = o.tags.includes("ACADEMIC")
      ? academic
      : o.tags.includes("SCHOOL")
      ? school
      : o.tags.includes("PRACTITIONER")
      ? practitioner
      : other;
    list.push(o);
  });

  const remappedMessage = occupationState.originalDetail.remapped
    ? `Your occuption was originally specified on an old registration form
using an occupation category we no longer use
(${occupationState.originalDetail.occupation.label}).
Please ensure the most accurate replacement category is selected below.`
    : null;

  return (
    <Fragment>
      {remappedMessage ? <ErrorMessage>{remappedMessage}</ErrorMessage> : null}
      <Columns>
        {displayOrder.map((column, columnNumber) => (
          <Columns.Column key={columnNumber} size="half">
            {column.map((display, index) => (
              <Field key={index}>
                <Label>{display.label}</Label>
                {display.list.map((occupation) => (
                  <RadioColumns
                    key={occupation.id}
                    name="occupation-select"
                    value={selectedId}
                    optionValue={occupation.id}
                    onChange={onChange}
                  >
                    {occupation.label}
                    {occupation.extra_prompt
                      ? " " + occupation.extra_prompt
                      : null}
                  </RadioColumns>
                ))}
              </Field>
            ))}
          </Columns.Column>
        ))}
      </Columns>
    </Fragment>
  );
}

export default PromptOccupation;
